// Inline error display with an optional Retry button. Used by every page
// that fans out a network fetch. Accepts an Error instance or raw string —
// pages catching from fetch() typically get Error, but constructed messages
// (e.g. "WebSocket disconnected") stay strings.
//
// On Soft: a quiet red-tinted plate with no rim, the failed toast's mark (an
// exclamation in a circle) before the words, Retry a small raised button.

import { WarningCircleIcon } from '@phosphor-icons/react'
import soft from '../../styles/soft.module.css'
import styles from './common.module.css'

interface Props {
  error: Error | string
  onRetry?: () => void
}

export function ErrorBanner({ error, onRetry }: Props) {
  const msg = typeof error === 'string' ? error : error.message
  return (
    <div className={styles.errorBanner} role="alert">
      <span className={styles.errorText}>
        <WarningCircleIcon size={16} weight="bold" aria-hidden="true" />
        {msg}
      </span>
      {onRetry && (
        <button type="button" onClick={onRetry} className={`${soft.btn} ${styles.retryBtn}`}>
          Retry
        </button>
      )}
    </div>
  )
}
